import React from "react";
import {
    Box,
    Grid,
    Skeleton,
    Card,
    Divider,
} from "@mui/material";

const ProductPageSkeleton: React.FC = () => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                padding: 3,
                backgroundColor: "#fff",
                margin: "20px auto",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                maxWidth: "1200px",
            }}
        >
            <Grid container spacing={2}>
                {/* Left Thumbnail List */}
                <Grid item xs={2}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            border: "1px solid #ddd",
                            borderRadius: 2,
                            width: 124,
                            overflow: "hidden",
                            justifyContent: "center",
                            padding: 1,
                        }}
                    >
                        {[1, 2, 3, 4].map((_, i) => (
                            <Skeleton
                                key={i}
                                variant="rectangular"
                                width={120}
                                height={180}
                                sx={{ borderRadius: 1 }}
                            />
                        ))}
                    </Box>
                </Grid>

                {/* Main Preview Image */}
                <Grid item xs={5}>
                    <Skeleton
                        variant="rectangular"
                        height={400}
                        sx={{
                            width: "100%",
                            borderRadius: "4px",
                            border: "1px solid #ddd",
                        }}
                    />
                </Grid>

                {/* Product Details */}
                <Grid item xs={5}>
                    <Card sx={{ padding: 3 }}>
                        {/* Category */}
                        <Skeleton width={200} height={20} />

                        {/* Title */}
                        <Skeleton width="70%" height={32} sx={{ mt: 2 }} />

                        {/* Price */}
                        <Skeleton width="40%" height={28} sx={{ mt: 2, mb: 2 }} />

                        <Divider />

                        {/* Options */}
                        {[1, 2].map((_, i) => (
                            <Box key={i} sx={{ mt: 3 }}>
                                <Skeleton width={120} height={22} />
                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
                                    {[1, 2, 3, 4].map((_, index) => (
                                        <Skeleton
                                            key={index}
                                            variant="rectangular"
                                            width={80}
                                            height={36}
                                            sx={{ borderRadius: 1 }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        ))}

                        {/* Quantity */}
                        <Skeleton width={140} height={22} sx={{ mt: 3 }} />
                        <Skeleton
                            variant="rectangular"
                            width={120}
                            height={40}
                            sx={{ mt: 1, borderRadius: 1 }}
                        />

                        {/* Buttons */}
                        <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={50}
                                sx={{ borderRadius: 1 }}
                            />
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={50}
                                sx={{ borderRadius: 1 }}
                            />
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ProductPageSkeleton;
